import { useEffect } from 'react';
import { useWorkflowSocket } from '../../features/workflow/hub/useWorkflowSocket';

export const InactiveCheck = () => {
  const inactive = useWorkflowSocket((r) => r.data?.inactive);
  const invoke = useWorkflowSocket((r) => r.invoke);
  useEffect(() => {
    if (inactive) {
      invoke('Leave', true);
    }
  }, [inactive, invoke]);

  return <></>;
};
